import { ChangeEvent, useCallback, useState } from "react"

function useFormState<T>(initialState: T) {
   const [state, setState] = useState<T>(initialState)

   const updateField = useCallback(
      <K extends keyof T>(name: K, value: T[K]) => {
         setState((prevState) => ({
            ...prevState,
            [name]: value,
         }))
      },
      []
   )

   const handleChange = useCallback(
      (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
         const { name, value } = e.target
         updateField(name as keyof T, value as T[keyof T])
      },
      [updateField]
   )

   const resetForm = useCallback(
      (newState: T = initialState) => {
         setState(newState)
      },
      [initialState]
   )

   return {
      state,
      updateField,
      handleChange,
      resetForm,
   }
}

export default useFormState
